/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import PageBackButton from './PageBackButton';

const PageLayout = ({ title, headerRightContent, backButton, children, fullWidth = false }) => {
  const wrapperClass = fullWidth
    ? 'my-2 sm:my-4 md:my-6 w-full'
    : 'my-2 sm:my-4 md:my-6 mx-auto max-w-7xl';

  const hasBackButton = Boolean(backButton);
  const backButtonProps = backButton && typeof backButton === 'object' ? backButton : {};

  return (
    <Card className={wrapperClass}>
      {(title || headerRightContent || hasBackButton) && (
        <CardHeader className="flex flex-col sm:flex-row gap-3 sm:justify-between sm:items-center border-b border-borderDefault p-3 sm:p-6">
          <div className="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center">
            {hasBackButton && <PageBackButton {...backButtonProps} />}
            {title && (
              <CardTitle className="min-w-0 text-xl sm:text-2xl md:text-3xl text-primary">
                {title}
              </CardTitle>
            )}
          </div>
          {headerRightContent && <div className="self-start sm:self-auto">{headerRightContent}</div>}
        </CardHeader>
      )}
      <CardContent className="p-3 sm:p-6">
        {children}
      </CardContent>
    </Card>
  );
};

export default PageLayout;
